import { Directive, createVNode, render } from "vue";
import { UiSkeleton } from "@packages/component-library";

export const vSkeleton: Directive = {
  mounted(el, { value: isLoading, modifiers }) {
    const wrapper = document.createElement("div");
    wrapper.style.position = "relative";
    wrapper.style.display = "block";

    const originalStyles = {
      position: el.style.position,
      visibility: el.style.visibility,
      opacity: el.style.opacity,
      pointerEvents: el.style.pointerEvents,
    };

    el.parentNode?.insertBefore(wrapper, el);
    wrapper.appendChild(el);

    const createSkeleton = () => {
      const skeletonVNode = createVNode(UiSkeleton, {
        type: "card",
        style: {
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          zIndex: 1,
        },
      });

      const skeletonContainer = document.createElement("div");
      skeletonContainer.style.position = "absolute";
      skeletonContainer.style.inset = "0";
      render(skeletonVNode, skeletonContainer);
      return skeletonContainer;
    };

    el._skeleton = createSkeleton();
    wrapper.appendChild(el._skeleton);

    el._resizeObserver = new ResizeObserver(() => {
      if (el._skeleton) {
        const rect = el.getBoundingClientRect();
        el._skeleton.style.width = `${rect.width}px`;
        el._skeleton.style.height = `${rect.height}px`;
      }
    });

    const updateVisibility = (loading: boolean) => {
      if (loading) {
        el.style.opacity = "0";
        el.style.pointerEvents = "none";
        el._skeleton.style.display = "block";
      } else {
        el.style.opacity = "1";
        el.style.pointerEvents = "auto";
        el._skeleton.style.display = "none";
      }
    };

    updateVisibility(isLoading);
    el._resizeObserver.observe(el);

    el._wrapper = wrapper;
    el._originalStyles = originalStyles;
  },

  updated(el, { value: isLoading }) {
    el.style.opacity = isLoading ? "0" : "1";
    el.style.pointerEvents = isLoading ? "none" : "auto";
    el._skeleton.style.display = isLoading ? "block" : "none";
  },

  unmounted(el) {
    if (el._wrapper) {
      const parent = el._wrapper.parentNode;
      parent?.insertBefore(el, el._wrapper);
      parent?.removeChild(el._wrapper);
    }

    el._resizeObserver?.disconnect();
    delete el._skeleton;
    delete el._wrapper;
  },
};
